import './styles.css';
import { createGame } from './game/boot';
import { registerServiceWorker } from './pwa/registerSW';
import { OfflineIndicator } from './pwa/offlineIndicator';

/**
 * Application entry point.
 *  - boot the Phaser game into #game-root
 *  - register the service worker (offline / installable PWA)
 *  - wire the online/offline indicator
 *
 * The SW status is stashed in the Phaser registry so the debug overlay can read
 * it without a hard dependency between the PWA layer and the scene.
 */
const game = createGame('game-root');

const indicator = new OfflineIndicator();
const sw = registerServiceWorker();

function setSwStatus(status: string): void {
  // registry is available once the game has booted; guard just in case.
  game.registry?.set('swStatus', status);
}
setSwStatus('registering');

sw.onActivated(() => {
  setSwStatus('active');
  indicator.flashOfflineReady();
});
sw.onUpdateReady(() => {
  setSwStatus('update-ready');
});

// Prevent iOS Safari pinch-zoom / double-tap-zoom at the document level too.
for (const type of ['gesturestart', 'gesturechange', 'gestureend']) {
  document.addEventListener(type, (e) => e.preventDefault(), { passive: false });
}
document.addEventListener(
  'dblclick',
  (e) => {
    e.preventDefault();
  },
  { passive: false },
);
